import { ThreeDots } from "react-loader-spinner";
import "./Spinner.css";

const Spinner = () => (
  <div className="spinner_container">
    <ThreeDots color="#3a93ee" />
  </div>
);

export default Spinner;